import { isCancel, isAxiosError } from 'axios';
import { handleApiError } from '@/core/utils/handleApiError';
import { BadRequestError, isBadRequestError } from './badRequestError';
import { InlineApiError } from './requestErrorMode';

/** Обрабатывает ошибку API. */
export const rethrowHandledApiError = (
    error: unknown,
    display: 'default' | 'inline' = 'default'
): never => {
    if (isCancel(error)) throw error;

    const { message } = display === 'inline'
        ? handleApiError(error, display)
        : handleApiError(error);

    if (display === 'inline') throw new InlineApiError(message, isAxiosError(error)
        ? error.response?.status
        : undefined);
    if (isBadRequestError(error)) throw new BadRequestError(message);
    throw new Error(message);
};
